import ResidentialPolicy from './residential-policy'
export default ResidentialPolicy
